module.exports = __webpack_public_path__ + "static/tarifa-bg-532295aff1bc2fb2b07e664c3e5bddd2.jpg";